// 選單圓點的資料來源（ROADMAP #3：全域狀態用 TanStack Query，即時推播收到事件就讓查詢重抓，不另外引入狀態管理套件）。
// 舊版是 App.jsx 掛載時抓一次、MERCHANT_PRICING_* 事件時再抓，寫進 store；這裡改成 query＋推播 invalidate（見 useRealtime）。
import { useQuery } from '@tanstack/react-query'
import { request } from '@/lib/request'
import { access } from '@/lib/auth'

export const PRICING_PENDING_KEY = ['merchant', 'pricing-pending-count']

export function useMenuBadges() {
  const pricing = useQuery({
    queryKey: PRICING_PENDING_KEY,
    queryFn: ({ signal }) => request.get('/api/v1/merchants/count-pricing-pending-approvals', { signal }),
    // 同舊版：沒有審核權限就不抓，圓點永遠不亮
    enabled: access('approve merchant pricing'),
    select: (n) => Number(n) || 0,
    // 由推播事件觸發更新，不靠時間過期重抓
    staleTime: Infinity,
  })
  return { pricingPending: (pricing.data ?? 0) > 0 }
}
